module.exports = __webpack_public_path__ + "img/elementwidths_jasp.bcf299a3.png";